import Modal from "react-modal";

import { useDispatch } from "react-redux";
import useAppAccessor from "../../../../hooks/useappAccessor";
import {
  getBrandShopify,
  setInteractionData,
  setShopifyAllData,
  setSelectedInteractionData,
} from "../../interaction.actions";
import { TfiClose } from "react-icons/tfi";
import { saveInteractionAPI } from "../../../../services/record.service";
import NoResult from "../../../../components/NoResult";
import { useEffect, useState } from "react";
import { BiSearch } from "react-icons/bi";
import {
  payloadBeyondShopify,
  payloadBeyondShopifyBrand,
  payloadBrandDefault,
  payloadShopifyDefault,
  payloadTranontShopify,
  payloadTranontShopifyBrand,
  payloadSoundShopifyBrand,
  payloadSoundShopify,
  payloadYoliShopify,
  payloadYoliShopifyBrand,
} from "./constants";
import { getBrandColor } from "../../../../utils/brand.util";
import {
  getBrandShopifyService,
  getItemShopifyService,
} from "../../../../services/shopify.service";
import SelectFilterShopify from "../brandFilterShopify";
import { toast } from "react-toastify";

let listenerAdded:boolean = false;
let timeoutId:any = null;
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    height: "85%",
    width: "80%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: 0,
    border: 0,
    backgroundColor: "#000000",
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
  },
  overlay: {
    backgroundColor: "rgba(24, 24, 24,0.8)",
    zIndex: 99999,
  },
};

const ShopifyInteraction = (props: any) => {
  const dispatch = useDispatch();

  const { getInteractions, getLiveMainData, getUserData } = useAppAccessor();
  const { language } = getUserData();
  const { user } = getUserData();
  const { publicUserData } = user;
  const {
    interactionData,
    brandShopifyData,
    selectedInteraction,
    shopifyAllData,
  } = getInteractions();
  const { configurationData } = getLiveMainData();
  const {client} = getUserData();
  const [loading, setLoading] = useState(false);
  const [productsDetailData, setProductsDetailData] = useState<any>([]);
  const [productsBrandData, setProductsBrandData] = useState([]);
  const [productsBrandDataTemp, setProductsBrandDataTemp] = useState([]);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [interactionDataArray, setInteractionDataArray] = useState<any>([]);
  const [payloadCheck, setPayloadCheck] = useState<any>(null);
  const [payloadCheckBrand, setPayloadCheckBrand] = useState(null);
  const [productsDetailDataTemp, setProductsDetailDataTemp] = useState<any>([])
  const time = Date.now();

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    // setIsOpen(false);
    listenerAdded = false;
    timeoutId = null;
    props.handleCloseMediaInteraction(false);
  }

  function handleSelectItem(items: any) {
    const isSelected = selectedItems.includes(items);
    if (isSelected) {
      setSelectedItems(
        selectedItems.filter((selectedItem: any) => selectedItem !== items)
      );
    } else {
      if (!checkElementPresentInArray(items?.sku)) {
        setSelectedItems([...selectedItems, items]);
      } else {
        toast(`${items.title} ${language['already_in_interactions']}.`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
  }

  function searchItems(items: any, searchTerm: any) {
    return items?.filter((item: any) => {
      return item?.title.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }

  const addInteractionDataToArray = (item: any) => {
    selectedItems.forEach((item: any) => {

      setInteractionDataArray((prevArray: any) => [
        ...prevArray,
        {
          attributes: {
            action: item?.workable_purchase_link,
            label: item?.title,
            isLinkedToStore: false,
            assetId: `${item?.id}`,
            description: item?.description,
            price: item.price,
            createdOn: `${time}`,
            isDefault: false,
            eCommerce: false,
            shouldShow: true,
            labelVisible: true,
            thirdPartyUsername: "",
            isProduct: true,
            productMaxPrice: item?.maximumPrice,
            productMinPrice: item?.minimumPrice,
            zyiaSymbolSuffix: "",
            siteName: "shop",
            hostUserName: "",
            isMAShop: true,
            rotatable: true,
            draggable: true,
            scalable: true,
            deletable: true,
            editable: true,
            iframeable: true,
            maximumPriceString: item?.maximumPrice,
            minimumPriceString: item?.minimumPrice,
          },
          style: {
            style_type: "photo",
            pulse_animation: false,
            opacity: 1,
            thumbnail_url: item?.image_url,
          },
          center_x: 50,
          center_y: 50,
          rotation_angle: 0,
          start: 0,
          end: 5,
          height_max: 100,
          height_pc: 17,
          interaction_id: configurationData?.company_name == "Sound Concepts Demo" ?  `${item?.id}` : `${item?.sku}`,
          interaction_subtype: "other",
          interaction_type: "media",
          width_max: 100,
          width_pc: 8,
          featured: false,
        },
      ]);
    });

    setTimeout(() => {
      props.handleCloseMediaInteraction(true);
    }, 200);
  };

  const checkElementPresentInArray = (id: any) => {
    return interactionDataArray.some(
      (element: any) => element.interaction_id === id
    );
  };

  const handleChangeFilter = async (companyName: string) => {
    switch (companyName) {
      case "Yoli":
        if (productsBrandDataTemp) {
          const payload = {
            store_url: "https://verb-yoli-crm.myshopify.com",
            store_api_key: "182ed15e83085e14cbf8fa1d71a0c635",
            store_type: "shopify",
            query: "",
            tag: `${productsBrandDataTemp}`,
            last_item: "",
            shop_site_name: "",
          };
          getItemShopifyService(payload).then((item) => {
            dispatch(setShopifyAllData(item?.data));
            setProductsDetailData(interactionData?.products);
          });
          setSelectedItems([]);
        }
        break;

      case "zyiaactive":
        if (productsBrandDataTemp) {
          const payload = {
            site_id: "",
            store_url: "https://verb-zyia-crm.myshopify.com",
            store_api_key: "bf70238ceeff4fd964335983541f49c4",
            store_type: "shopify",
            query: "",
            tag: `${productsBrandDataTemp}`,
            last_item: "",
            shop_site_name: "",
          };
          getItemShopifyService(payload).then((item) => {
            dispatch(setShopifyAllData(item?.data));
            setProductsDetailData(interactionData?.products);
          });
          setSelectedItems([]);
        }
        break;

      case "beyondslim":
        if (productsBrandDataTemp) {
          const payload = {
            site_id: "",
            store_url: "https://verb-beyondslim-crm.myshopify.com",
            store_api_key: "65b9d2851dd9435bfceb7da871e6e9d5",
            store_type: "shopify",
            query: "",
            tag: `${productsBrandDataTemp}`,
            last_item: "",
            shop_site_name: "",
          };
          getItemShopifyService(payload).then((item) => {
            dispatch(setShopifyAllData(item?.data));
            setProductsDetailData(interactionData?.products);
          });
          setSelectedItems([]);
        }
        break;

      case "tranont":
        if (productsBrandDataTemp) {
          const payload = {
            "site_id":"",
            store_api_key: publicUserData.store_api_key,
            store_type: publicUserData.store_type,
            store_url: publicUserData.store_url,
            "query":"",
            "tag":`${Array.isArray(productsBrandDataTemp) ? "" : productsBrandDataTemp}`,
            "last_item":"",
            "shop_site_name":""
          };
          getItemShopifyService(payload).then((item) => {
            dispatch(setShopifyAllData(item));
            setProductsDetailData(interactionData?.products);
          });
          setSelectedItems([]);
          setProductsDetailDataTemp([]);
        }
        break;
      case "Sound Concepts ":
      case "Sound Concepts Demo":
        if (productsBrandDataTemp) {
          const payload = {
            site_id: "",
            store_url: "https://soundconcepts.myshopify.com",
            store_api_key: "651b28203333874a8e5f20f91797478d",
            store_type: "shopify",
            query: "",
            tag: `${productsBrandDataTemp}`,
            last_item: "",
            shop_site_name: "",
          };
          getItemShopifyService(payload).then((item) => {
            dispatch(setShopifyAllData(item));
            setProductsDetailData(interactionData?.products);
          });
          setSelectedItems([]);
          setProductsDetailDataTemp([]);
        }
        break;


      default:
        break;
    }
  };


  function getMoreItem() {
    setProductsDetailData((prev:any) => {
      setPayloadCheck({ ...payloadCheck, last_item: prev[prev.length - 1]?.cursor});
      return prev;
    })
  }


  function checkShopPayLoad(companyName: string) {
    switch (companyName) {
      case "Yoli": {
        setPayloadCheck(payloadYoliShopify);
        setPayloadCheckBrand(payloadYoliShopifyBrand);
        break;
      }
      case "zyiaactive": {
        setPayloadCheck(payloadShopifyDefault);
        setPayloadCheckBrand(payloadBrandDefault);
        break;
      }
      case "beyondslim": {
        setPayloadCheck(payloadBeyondShopify);
        setPayloadCheckBrand(payloadBeyondShopifyBrand);
        break;
      }
      case "tranont": {
        setPayloadCheck({...payloadTranontShopify, 
          store_api_key: publicUserData.store_api_key,
          store_type: publicUserData.store_type,
          store_url: publicUserData.store_url,});
        setPayloadCheckBrand({...payloadTranontShopifyBrand,
          store_api_key: publicUserData.store_api_key,
          store_type: publicUserData.store_type,
          store_url: publicUserData.store_url,});
        break;
      }
      case "Sound Concepts":
      case "Sound Concepts Demo": {
        setPayloadCheck(payloadSoundShopify);
        setPayloadCheckBrand(payloadSoundShopifyBrand);
        break;
      }

      default:
        break;
    }
  }

  useEffect(() => {
    if (interactionData.length > 0) {
      setInteractionDataArray(interactionData);
    }
    checkShopPayLoad(configurationData?.company_name);

  }, []);

  useEffect(() => {
    if (payloadCheck == null) return ;
    setLoading(true);
    const container = document.getElementById('list-shopify-container');

    if (container && !listenerAdded) {
      listenerAdded = true;
      container?.addEventListener('scroll', function() {
        if (container.scrollTop + container.clientHeight >= container.scrollHeight - 30) {
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          timeoutId = setTimeout(() => {
            getMoreItem();
          }, 300);
        }
      });
    }
    
    var temp = {...payloadCheck,
      store_api_key: publicUserData.store_api_key,
      store_type: publicUserData.store_type,
      store_url: publicUserData.store_url,
       tag: (Array.isArray(productsBrandDataTemp) ? "" : productsBrandDataTemp)};
    getItemShopifyService(temp)
      .then((item: any) => {
        if (item?.data) {
          dispatch(setShopifyAllData(item?.data));
        } else {
          if (item.products && item.products.length > 0) {
            dispatch(setShopifyAllData(item));
          }
        }
        if (item?.data) {
          // setProductsDetailData((prev:any) => [...prev, ...item?.data['products']]);
          setProductsDetailDataTemp((prev:any) => [...prev, ...item?.data['products']]);
        } else {
          // setProductsDetailData((prev:any) => [...prev, ...item['products']]);
          setProductsDetailDataTemp((prev:any) => {
           return [...prev, ...item['products']];
          });
        }
      })
      .catch((error) => {
       // console.log("error: " + error);
      });

    getBrandShopifyService(payloadCheckBrand)
      .then((item: any) => {
        if (item?.error) {
          return ;
        } else {
            if(item?.data) {
            dispatch(getBrandShopify(item?.data));
          } else {
            dispatch(getBrandShopify(item));
          }
        }
      })
      .catch((error) => {
       // console.log("error: " + error);
      });
    setLoading(false);
  }, [payloadCheck]);

  useEffect(() =>{
    if(productsBrandDataTemp) {
      const totalProducts = []?.concat(...productsDetailDataTemp.filter((arr:any) => arr !== undefined));
      const filteredProducts = totalProducts.filter((x:any) => x?.sku !== null && x?.sku !== undefined);
     
      // setProductsDetailData([...filteredProducts]);
    }
  },[productsDetailDataTemp])

  useEffect(() => {
    if (searchTerm) {
      setProductsDetailData(
        searchItems(shopifyAllData["products"], searchTerm)
      );
    } 
    else {
      // setProductsDetailData(shopifyAllData?.products);
      setProductsDetailData((prev:any) => {
        if (prev && prev.length > 0) {
         // console.log("prev==>", prev);
         return [...prev, ...shopifyAllData?.products];
        } else {
          return shopifyAllData?.products;
        }
      });
    }
  }, [shopifyAllData]);

  useEffect(() => {
    setProductsBrandData(brandShopifyData);
  }, [brandShopifyData]);

  useEffect(() => {
    handleChangeFilter(configurationData?.company_name);

    if (searchTerm) {
      setProductsDetailData(
        searchItems(shopifyAllData["products"], searchTerm)
      );
    }
  }, [productsBrandDataTemp]);

  useEffect(() => {
    setProductsDetailData(searchItems(shopifyAllData["products"], searchTerm));
  }, [searchTerm]);

  useEffect(() => {
    if (interactionDataArray.length > 0) {
      dispatch(setInteractionData(interactionDataArray));
      saveInteractionAPI(
        configurationData?.stream_id,
        interactionDataArray
        // interactionDataArray?.filter(
        //   (data: any) => data.attributes.shouldShow === true
        // )
      );
    }
  }, [interactionDataArray]);

  return (
    <Modal
      isOpen={props.modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="flex w-full h-full bg-neutral-800" id={"ModalInner"}>
        <div className="flex flex-col w-full bg-black  rounded-lg p-4">
          <div className="flex w-full justify-between">
            <span className="text-white text-2xl font-medium">
              {configurationData?.company_name}
            </span>
            <TfiClose
              color="#DEDEDE"
              size={20}
              cursor="pointer"
              className="mr-2"
              onClick={() => {
                closeModal();
              }}
            />
          </div>
          <div className="w-full bg-white h-0.5 my-2" />
          <div>
            <span className="text-white">
              {language['select_products_prompt']}
            </span>
          </div>
          <div className="flex flex-row my-2" style={{ zIndex: 1 }}>
            <SelectFilterShopify
              defaultSelectedItem={"Filter by"}
              data={productsBrandData}
              onSelect={(item: any) => {
                setProductsBrandDataTemp(item);
              }}
            />

            <div className="flex border-2 border-zinc-700 w-[60%] rounded-lg ml-6 items-center px-4">
              <BiSearch fill="white" size="24" />
              <input
                className="flex-grow bg-black text-white pl-2 outline-none placeholder:text-white"
                placeholder={language['search_label']}
                onChange={(event) => setSearchTerm(event.target.value)}
              />
            </div>
            {/* <div
              className="h-12 w-64 flex items-center justify-center bg-neutral-600  rounded-lg ml-[40%] cursor-pointer fixed right-5"
              onClick={getMoreItem}
            >
              <h1 className="text-gray-300 text-2xl">Load More</h1>
            </div> */}
          </div>
          <div id={'list-shopify-container'} className="h-full w-full overflow-y-scroll containerModal">
            {productsDetailData && productsDetailData.length == 0 ? (
              loading ? (
                <div className="flex justify-center items-center h-full">
                  <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-white"></div>
                </div>
              ) : (
                <NoResult></NoResult>
              )
            ) : (
              <>
                <div className="grid grid-cols-6 gap-2 ">
                  {productsDetailData?.map((item: any, index:any) => {
                    const isSelected = selectedItems.includes(item);

                    return (
                      <div
                        className={`flex flex-col p-2 ${
                          isSelected ? "selected-item" : ""
                        }`}
                        key={item?.id}
                        onClick={() => handleSelectItem(item)}
                      >
                        <div className="rounded-lg inset-0 w-full h-44 bg-zinc-300">
                          {isSelected && <div className="selected-indicator"
                            style={{backgroundColor: `${getBrandColor(client)} `}}

                          />}

                          <img
                            className="h-full w-full object-cover object-center rounded-lg"
                            src={`${item?.image_url}`}
                            onError={(event) => {
                              event.currentTarget.src =
                                "https://andersnoren.se/themes/koji/wp-content/themes/koji/assets/images/default-fallback-image.png";
                            }}
                            alt=""
                          />
                        </div>
                        <div className="text-white mt-2 line-clamp-2">
                        <div dangerouslySetInnerHTML={{ __html: item?.title }} />
                          {/* {item?.title} */}
                        </div>
                        {/* <div className="text-white mt-2 line-clamp-2">
                        {item?.description}
                      </div> */}
                        <div className="text-white mt-2 line-clamp-2 text-base font-medium">
                          {/* ${item?.minimumPrice} - ${item?.maximumPrice} */}$
                          {item?.price}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {selectedItems.length > 0 && (
                  <div
                    className="h-12 w-64 flex items-center justify-center bg-[#6DADFF] rounded-lg ml-[40%] cursor-pointer fixed bottom-4"
                    onClick={() => addInteractionDataToArray(selectedItems)}
                    style={{backgroundColor: `${getBrandColor(client)} `}}
                  >
                    <span className="text-white text-2xl">Add</span>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ShopifyInteraction;
